import { Box, styled } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  flexGrow: 1,
  height: "100%",
}));

const TabPanelBox = withDefaultProps(Box, { className: "customScrollbars" });
export const TabPanel = styled(TabPanelBox)(({ theme }) => ({
  display: "flex",
  flexGrow: 1,
  overflow: "auto",
}));
